import React, { useRef, useEffect, useCallback, useState} from 'react';
import ParameterBox from 'components/instruments/ParameterBox.js';
import {connect} from 'react-redux';

const AccumulatorDepth = ({depth, i, parameter, accumulator, isDraggable}) => { 
    const [editing, setEditing] = useState(undefined);
    const [value, setValue] = useState(depth);
    const ref = useRef(undefined);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            let _value = parseFloat(value);
            if (isNaN(_value)) {
                return;
            }
            accumulator.depthParameters[i].set(_value);
            setEditing(false);
        }
    }, [setEditing, i, parameter, value, accumulator]);

    useEffect(() => {
        if (ref.current && editing) {
            ref.current.focus();
            ref.current.select();
        }
    }, [editing]);

    /*
    if (editing) {
        return (
            <input
              ref={ref}
              onKeyDown={onKeyDown}
              onChange={(e) => setValue(e.target.value)}
              className="depth-input" value={value}/>
        );
    }
    return (
        <div
          onClick={() => setEditing(true)}
          className="depth">
          {depth} %
        </div>
    );
    */
    return (
        <ParameterBox
          isDraggable={isDraggable}
          track={accumulator.track}
          parameter={accumulator.depthParameters[i]}
          units="%"
          stopPropagation={false}
        />
    );
}

const mapStateToProps = (state, props) => {
  return {
      depth: props.accumulator.getDepth(props.i)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccumulatorDepth);
